module.exports = __webpack_public_path__ + "static/56-9d3692514f95108158b2fe516cbf6115.jpg";